import { isArticlePage, isGalleryPage, isNewsYouCanUsePage, isPremiumPageV2 } from '../../utils/aem-utils';

export const readingProgressBarModule = {
  name: 'Reading Progress Bar',
  shouldInit: ($paragraphs) => {
    const isArticlePageWithBar = isArticlePage() && !isPremiumPageV2();
    return ((isArticlePageWithBar || isNewsYouCanUsePage()) && $paragraphs.length) || isGalleryPage();
  },
};
